module.exports = __webpack_public_path__ + "img/logo.978f7468.png";